























import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";
import CountryLabelV2 from "../CountryLabelV2/index.vue";
import {toSlug} from "@/shared/services/helper/utils";
import {CountryStore} from "@/modules/regionsv2/country/store";

@Component({
    name: "CountrySelectorV2",
    components: {CountryLabelV2}
})
export default class extends Vue {
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';
    @Model("change", { type: Number })
    readonly countryId!: number;

    @Emit('change')
    handleChange(value: number) {
        return value;
    }

    get countryIds(): number[] {
        return CountryStore.ids;
    }

    async created() {
        try {
            if (!CountryStore.ids?.length)
                await CountryStore.getCountriesV2();
        } catch (e) {
            this.$notification.error({ message: "Thất bại", description: e?.response?.data?.message || "Đã có lỗi xảy ra" });
        }
    }

    private filterOption(input: string, option: any) {
        return (toSlug(option.componentOptions.children[0].elm.textContent, " ")
                .toLowerCase()
                .indexOf(toSlug(input, " ")
                .toLowerCase()) >= 0);
    }
}
